import { render, staticRenderFns } from "./scope90.vue?vue&type=template&id=64d005bc&scoped=true"
import script from "./scope90.vue?vue&type=script&lang=js"
export * from "./scope90.vue?vue&type=script&lang=js"
import style0 from "./scope90.vue?vue&type=style&index=0&id=64d005bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d005bc",
  null
  
)

export default component.exports